<template>
  <div>
    <div class="text-h4 mb-2">Информация о стенде</div>

    <div class="d-flex">
      <div class="text-caption mr-2">stageName:</div>
      <div class="text-body-2">
        {{ stageName }}
      </div>

      <span
        class="mdi mdi-content-copy cursor-pointer ml-1"
        style="font-size: 12px"
        @click="copyToBuffer(stageName)"
      />
    </div>

    <div class="d-flex">
      <div class="text-caption mr-2">commitSHA:</div>
      <div class="text-body-2">
        {{ commitSHA }}
      </div>

      <span
        class="mdi mdi-content-copy cursor-pointer ml-1"
        style="font-size: 12px"
        @click="copyToBuffer(commitSHA)"
      />
    </div>

    <div class="d-flex">
      <div class="text-caption mr-2">buildTimestamp:</div>
      <div class="text-body-2">
        {{ buildTimestamp }}
      </div>

      <span
        class="mdi mdi-content-copy cursor-pointer ml-1"
        style="font-size: 12px"
        @click="copyToBuffer(buildTimestamp)"
      />
    </div>

    <div
      class="d-flex mt-2 cursor-pointer"
      @click="copyAllMetaData"
    >
      <div class="text-caption mr-2">Скопировать все</div>
      <span
        class="mdi mdi-content-copy ml-1"
        style="font-size: 12px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const { stageName, buildTimestamp, commitSHA } = useRuntimeConfig().public.buildMetaData;

function copyAllMetaData() {
  return copyToBuffer(
    `Информация о стенде\nstageName: ${stageName}\ncommitSHA: ${commitSHA}\nbuildTimestamp: ${buildTimestamp}`,
  );
}

async function copyToBuffer(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error('Ошибка при копировании в буфер обмена: ', err);
    useToast().error('Ошибка при копировании в буфер обмена');
  }
}
</script>

<style lang="scss" scoped></style>
